<div style="background-color:#fff;">
  <div *ngIf="!containsRawHTML" class="upsellDownsell">
      <header-with-menu [showLogo]="showHeaderLogo" [icon]="icon" [showContent]="showHeaderContent"
      [displayPhone]="displayPhone" [phone]="phone" [phoneIcon]="phoneIcon" [showOnUpsell]="showHeaderOnUpsell"
      [cartQuantity]="originalPurchaseQuantity"></header-with-menu> 

    <!-- INSERT HEADER HERE -->
    <div class="upDownPage paddedforEmpty" no-padding>
      <ng-container *ngFor="let content of pageContents; let i = index;">
          <div *ngIf="content.type == 'html'">
            <div class="content{{ i + 1 }}col {{ content.name }}Content" [innerHTML]="content.html">
            </div>
          </div>

          <ng-container *ngIf="content.type == 'component'">
            <ng-container>
              <ng-container *ngIf="content.componentName == 'progress-bar'">
                 <progress-bar *ngIf="totalProductsSummary" [total]="minForFreeShipping" [current]="totalProductsSummary"
                  [title]="progressBarTitle" [logo]="progressBarLogo" [subTitle]="progressBarSubTitle"
                  [customText]="progressBarCustomText"></progress-bar> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-steps'">
                    <upsell-steps [steps]="steps_items" [stepLabel]="step_label" [newStepsStyle]="content.options?.newStepsStyle || false"></upsell-steps> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-wait'">
                 <upsell-wait [isFull]="wait_isFull" [title]="wait_title"
                  [description]="wait_description" [iconWait]="iconImgWait">
                </upsell-wait> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'simple-video-player'">
                 <simple-video-player [videoID]="content.options.videoID"
                  [videoMessageTitle]="content.options.videoMessageTitle" [videoMessage]="content.options.videoMessage"
                  [autoplay]="content.options.autoplay">
                </simple-video-player> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'video-player'">
                 <video-player [videoID]="content.options.videoID"
                  [videoMessageTitle]="content.options.videoMessageTitle" [videoMessage]="content.options.videoMessage"
                  [videoPlayType]="content.options.videoPlayType">

                </video-player> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-section'">
                 <upsell-section [content]="content.options"></upsell-section> 
              </ng-container>
              
              <ng-container *ngIf="content.componentName == 'upsell-why'">
                 <upsell-why [content]="content.options || upsellWhyData"></upsell-why> 
              </ng-container>
              
              <ng-container *ngIf="content.componentName == 'upsell-product-box'">
                
                <upsell-product-box [currency]="currency" [braintreeCurrencyConversion]="braintreeCurrencyConversion" [title]="product_box_title"
                  [image]="productImage" [imageAlt]="productTitle"
                  [subTitle]="product_box_subTitle" [regularPrice]="productRegularPrice"
                  [instantSavings]="productInstantSavings" [yourPriceText]="product_box_yourPriceText"
                  [instantSavingsText]="product_box_instantSavingsText" [regularText]="product_box_regularText"
                  [yourPrice]="productYourPrice" [auxImg]="auxImg" [auxImgAlt]="auxImgAlt" 
                  [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productBoxCTA]="productBoxCTA"
                  (eventEmitter)="nextPage($event)">
                </upsell-product-box>
              
              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-product-box-full'">

                <upsell-product-box-full [currency]="currency" [braintreeCurrencyConversion]="braintreeCurrencyConversion" [title]="product_box_full_title"
                  [image]="productImage" [imageAlt]="productTitle" [additionalImage]="product_box_full_additionalImage"
                  [yourPriceText]="product_box_yourPriceText" [instantSavingsText]="product_box_instantSavingsText"
                  [regularText]="product_box_regularText" [regularPrice]="productRegularPrice"
                  [instantSavings]="productInstantSavings" [yourPrice]="productYourPrice"></upsell-product-box-full>

              </ng-container>
              <ng-container *ngIf="content.componentName == 'upsell-guarantee'">
                 <upsell-guarantee
                  [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText"
                  (eventEmitter)="nextPage($event)">
                </upsell-guarantee> 
              </ng-container>
              <ng-container *ngIf="content.componentName == 'brand-reviews'">
                 <brand-reviews [reviewsTitle]="reviewsTitle" [reviews]="reviews"
                  [perReviewAddOn]="perReviewAddOn"></brand-reviews> 
              </ng-container>
            </ng-container>
          </ng-container>
      </ng-container>
    </div>
    <!-- INSERT FOOTER HERE -->
    
    <upsell-footer [links]="footerLinks" [text]="footerText" [brand]="productBrand"
      [address]="footerAddress"></upsell-footer>
  </div>

  <div *ngIf="containsRawHTML" class="rawHTML"></div>
</div>
